import React from 'react';
import AddImage from '@wix/da-ds/pkg/Icons/24x24/AddImage';
import EditorImage from '@wix/da-ds/pkg/Icons/24x24/EditorImage';
import AddGallery from '@wix/da-ds/pkg/Icons/24x24/AddGallery';
import AddVideo from '@wix/da-ds/pkg/Icons/24x24/AddVideo';
import { useTranslation } from 'react-i18next';
import EditorIconButtonWithContextMenu from '../../menus/_partials/EditorIconButtonWithContextMenu';
import { useHandleDeviationClick } from './Deviation';
import { useVideoButton } from './Video';
import DaVideoPopup from '../../../extensions/extension-video/components/DaVideoPopup';
import { isExtensionInstalled } from '../../utils/tiptap';
import { useHandleGalleryClick } from './Gallery';
const AddMedia = ({ editor })=>{
    const { t } = useTranslation('editor');
    const handleDeviationClick = useHandleDeviationClick(editor);
    const handleGalleryClick = useHandleGalleryClick(editor);
    const { isModalShown, openModal: openVideoModal, closeModal: closeVideoModal, handleSubmit } = useVideoButton(editor);
    const items = [];
    if (isExtensionInstalled(editor, 'deviation')) {
        items.push({
            label: t('button.addMedia.addImage'),
            icon: /*#__PURE__*/ React.createElement(EditorImage, null),
            onClick: handleDeviationClick
        });
    }
    if (isExtensionInstalled(editor, 'gallery')) {
        items.push({
            label: t('button.addMedia.addGallery'),
            icon: /*#__PURE__*/ React.createElement(AddGallery, null),
            onClick: handleGalleryClick
        });
    }
    if (isExtensionInstalled(editor, 'daVideo')) {
        items.push({
            label: t('button.addMedia.addVideo'),
            icon: /*#__PURE__*/ React.createElement(AddVideo, null),
            onClick: openVideoModal
        });
    }
    if (!items.length) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(EditorIconButtonWithContextMenu, {
        icon: AddImage,
        items: items
    }), isModalShown && /*#__PURE__*/ React.createElement(DaVideoPopup, {
        onSubmit: handleSubmit,
        onCancel: closeVideoModal
    }));
};
AddMedia.displayName = 'AddMedia';
export default AddMedia;

//# sourceMappingURL=AddMedia.js.map